import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { useStore, useIsAdmin, useIsManager, useIsUser } from 'hooks';
import { Formik } from 'formik';
import { Info } from 'components/profile';
import { ProfileService } from 'services';

const InfoColumn = ({
  match: {
    params: { userId },
  },
  styles,
  profile,
  setSelectedContract,
  initialValues,
  validationSchema,
}) => {
  const { setUser, setLoading, setReload } = useStore();
  const [edit, setEdit] = useState(false);

  const role = profile?.role?.code;
  const isAdminProfile = useIsAdmin(role);
  const isManagerProfile = useIsManager(role);
  const isUserProfile = useIsUser(role);

  const onToggleEdit = () => setEdit(!edit);
  const onSubmit = async (values) => {
    setLoading(true);
    let response;

    const managementFields = {
      name: values.name,
      email: values.email,
    };

    if (isUserProfile) {
      response = await new ProfileService({ setUser })
        .updateUserProfile({ userId, ...values });
    } else if (isManagerProfile) {
      response = await new ProfileService({ setUser })
        .updateManagerProfile({ userId, ...managementFields });
    } else if (isAdminProfile) {
      response = await new ProfileService({ setUser })
        .updateAdminProfile({ userId, ...managementFields });
    }

    setLoading(false);
    if (response) {
      setEdit(false);
      setReload();
    }
  };

  const onChangeContract = (contractID) => {
    setSelectedContract(profile.contracts.find(contract => contract.id.toString() === contractID));
  };

  return profile ? (
    <div className={styles.column}>
      <div className={`${styles.inner} ${styles.info}`}>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
        >
          {({ handleSubmit, handleReset }) => (
            <Info
              edit={edit}
              profile={profile}
              onToggleEdit={onToggleEdit}
              onSubmit={handleSubmit}
              onReset={handleReset}
              onChangeContract={onChangeContract}
            />
          )}
        </Formik>
      </div>
    </div>
  ) : null;
};

export default withRouter(InfoColumn);
